module.exports = __webpack_public_path__ + "media/images/athletes/4315-b53680defb9fec96ae498e0d23d2e9e5.png";